import React, { useEffect, useState } from "react";
import FormSummaryTable from "../../experience/carecoordinator/formsummary/FormSummaryTable";
import { performPostRequest } from "../../service/network/NetworkService";
import IntentType from "../../intentexecutor/utils/IntentType";
import { getApiUrl } from "../../service/network/UrlMapper";
import ErrorNotificationComponent from "../../components/generic/error/ErrorNotificationComponent";
import { useGetOrgIdentifier } from "../../experience/generic/hooks/useGetOrgIdentifier";
import FormSummaryCard from "../../experience/carecoordinator/formsummary/FormSummaryCard";
import { getOrganizationTimestamp } from "../../utils/dateutils";

const mapTrendData = (data) => {
  return data >= 0 ? data : "--";
};

const InvoiceDetails = ({ billingPeriodStart, billingPeriodEnd, officeId, organizationTimeZone }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [formSummaryData, setFormSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getFormSummaryData = async () => {
      const payload = {
        organizationIdentifier,
        keyword: "",
        start_date: getOrganizationTimestamp(billingPeriodStart, organizationTimeZone),
        end_date: getOrganizationTimestamp(billingPeriodEnd, organizationTimeZone),
        status: [],
        filterByCreatedTimestamp: true,
        filledForms: true,
        ...(officeId != null && { officeId }),
      };
      setLoading(true);
      try {
        const result = await performPostRequest(
          getApiUrl()[IntentType.GET_BILLING_DATA],
          JSON.stringify(payload),
        );
        const resultJson = await result.json();
        setFormSummaryData(resultJson);
      } catch (error) {
        ErrorNotificationComponent(error);
      } finally {
        setLoading(false);
      }
    };

    getFormSummaryData();
  }, [
    billingPeriodEnd,
    billingPeriodStart,
    organizationIdentifier,
    setFormSummaryData,
    setLoading,
    officeId,
  ]);

  return (
    <>
      <div className="row card-bottomContent">
        <FormSummaryCard
          iconKey="volunteerGroup"
          cardNumber={mapTrendData(formSummaryData?.active_volunteers)}
          cardTitle="Active Volunteers"
          loading={loading}
          cardSubContent="Count of volunteers who have completed one or more visits"
        />
        <FormSummaryCard
          iconKey="report"
          cardNumber={mapTrendData(formSummaryData?.task_submitted)}
          cardTitle="Forms Submitted"
          loading={loading}
          cardSubContent="Total Forms submitted by volunteers"
        />
        <FormSummaryCard
          iconKey="patients"
          cardNumber={mapTrendData(formSummaryData?.patients_served)}
          cardTitle="Patients Served"
          loading={loading}
          cardSubContent="Number of patients served in the chosen time frame"
        />
      </div>
      <FormSummaryTable
        data={formSummaryData?.tasksSummary}
        loading={loading}
      />
    </>
  );
};

export default InvoiceDetails;
